import React from 'react';
import dayjs from 'dayjs';
import {
  useGlobalActions,
  useGlobalContext,
} from '../../../global-context/GlobalContext';
import { SpecialProduct } from '../../../interfaces/ISpecialOrder';
import './QuantitySelector.scss';
import { isEditableDate } from '../../../utils/calendarUtility';

interface QuantitySelectorProps {
  quantity: number;
  foodInfo: SpecialProduct;
  selectedDate?: any;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  foodInfo,
  selectedDate,
}) => {
  const { addToCart, removeFromCart } = useGlobalActions();
  const cutoffHours = useGlobalContext(c => c.specialOrder.cutoffHours);
  const allowEdit = isEditableDate(selectedDate, cutoffHours);
  const increaseQuantityChange = () => {
    if (allowEdit) addToCart(foodInfo);
  };

  const decreaseQuantityChange = () => {
    if (allowEdit) removeFromCart(foodInfo.productId);
  };

  return (
    <div className='quantity-selector'>
      <button
        onClick={decreaseQuantityChange}
        disabled={!allowEdit || quantity <= 0}
        className='quantity-selector-button-negative'
      >
        -
      </button>
      <span>{quantity}</span>
      <button
        onClick={increaseQuantityChange}
        disabled={!allowEdit}
        className='quantity-selector-button-positive'
      >
        +
      </button>
    </div>
  );
};

export const QuantitySelectorHorizontal: React.FC<QuantitySelectorProps> = ({
  quantity,
  foodInfo,
}) => {
  const { addToCart, removeFromCart } = useGlobalActions();

  const increaseQuantityChange = () => {
    addToCart(foodInfo);
  };

  const decreaseQuantityChange = () => {
    removeFromCart(foodInfo.productId);
  };

  return (
    <div className='quantity-selector-horizontal'>
      <button
        onClick={decreaseQuantityChange}
        disabled={quantity <= 0}
        className='quantity-selector-button-negative'
      >
        -
      </button>
      <span>{quantity}</span>
      <button
        onClick={increaseQuantityChange}
        className='quantity-selector-button-positive'
      >
        +
      </button>
    </div>
  );
};

export default QuantitySelector;
